import { render, staticRenderFns } from "./OrderNumber.vue?vue&type=template&id=62ec1b44&scoped=true&"
import script from "./OrderNumber.vue?vue&type=script&lang=js&"
export * from "./OrderNumber.vue?vue&type=script&lang=js&"
import style0 from "./OrderNumber.vue?vue&type=style&index=0&id=62ec1b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ec1b44",
  null
  
)

export default component.exports